var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React, { useMemo } from 'react';
import { createPrefixCls } from '../_utils/string';
import { StyleContext } from './context';
const prefixCls = createPrefixCls('cell-group');
export const CellGroup = (_a) => {
    var { children, className, align = 'right', labelWidth } = _a, restProps = __rest(_a, ["children", "className", "align", "labelWidth"]);
    const cellGroupCls = useMemo(() => {
        return classnames([prefixCls(), className]);
    }, [className]);
    return (React.createElement(StyleContext.Provider, { value: {
            align,
            labelWidth
        } },
        React.createElement("div", Object.assign({ className: cellGroupCls }, restProps), React.Children.map(children, (child) => {
            return React.isValidElement(child) && React.cloneElement(child);
        }))));
};
export default CellGroup;
